<template>
    <div class="info-layout">
        <div class="layout-picture">
            <CampaignPicture
                imgCls="default"
                :campaignImage="detailController.campaign.pictures"
                :campaign="detailController.campaign"/>
        </div>
        <div class="layout-info">
            <DetailInfo
                :lbl="lbl"
                :campaign="detailController.campaign" />
            <AddToCart
                :lbl="lbl"
                :campaign="detailController.campaign"
                :modalController="modalController"
            ></AddToCart>
        </div>
        <div class="layout-agency">
            <DetailAgency
                :lbl="lbl"
                :campaign="detailController.campaign"
            ></DetailAgency>
            <AddressDelivery
                :lbl="lbl"
                :campaign="detailController.campaign"
            ></AddressDelivery>
        </div>
    </div>
</template>

<script>

import CampaignPicture from '../detail/Picture.vue';
import DetailInfo from '../detail/DetailInfo.vue';
import DetailAgency from '../detail/DetailAgency.vue'
import AddToCart from '../detail/AddToCart.vue';
import AddressDelivery from '../detail/AddressDelivery.vue';

export default {
    name: 'info',
    components: {
        CampaignPicture,
        DetailInfo,
        DetailAgency,
        AddToCart,
        AddressDelivery
    },
    props: {
        isLogin: Boolean,
        lbl: Object,
        localeCode: Number,
        userPoint: Number,
        //controller
        detailController: Object,
        modalController: Object,
        redeemController: Object
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
@import './info.scss';
</style>
